import { NgModule } from '@angular/core';

export const ROUTE_ROLES = 'roles';
export const ROUTE_USERS = 'users';
export const ROUTE_GLOBAL_USERS = 'globalusers';
export const ROUTE_SITES = 'sites';

@NgModule({})
export class RouteConstantsModule { }
